import { TranslationKeys } from "./type";

const fr: TranslationKeys = {
    landingTitle: "Apprendre le code en s'amusant",
    landingSubtitle: "Des ateliers ludiques pour que vos enfants maîtrisent la technologie",
    landingCta: "Découvrir nos stages",
    landingSecondaryCta: "En savoir plus",

    featureTitle: "Venez apprendre avec nous !",
    feature1Title: "Apprentissage adapté",
    feature1Description: "Des cours qui vous ressemblent !",
    feature2Title: "Du choix",
    feature2Description: "Des cours disponibles dans plein de domaines différents",
    feature3Title: "Tout âge",
    feature3Description: "Les âges ne sont donnés qu'à titre indicatif venez donc tester !",
    feature4Title: "Apprentissage ludique",
    feature4Description: "Des cours mettant en avant la pratique avant tout !",




    programming: "Programmation adaptée",
    camps: "Cours flexibles",
    calendar: "Apprentissage ludique",
    contact: "Contact",
    followUs: "Suivez-nous",
    navHome: "Accueil",
    navCamps: "Stages",
    navPricing: "Tarifs",
    navCalendar: "Calendrier",
    navContact: "Contact",
    viewCamp: "Voir ce stage",
    faqTitle: "Questions fréquentes",
    faqSubtitle: "Tout ce que vous devez savoir sur nos stages",
    ctaTitle: "Prêt à commencer l'aventure ?",
    ctaDescription: "Rejoignez-nous pour un stage où la technologie rencontre la créativité",

    copyright: "© 2025 Rebootcamp. Tous droits réservés.",
    address: "Siège",
    addressLine1: "71 rue de roquebillière",
    addressLine2: "06300 Nice, France",
    phone: "Téléphone",
    email: "Email",
    contactTitle: "Contactez-nous",
    contactSubtitle: "Nous sommes là pour répondre à vos questions",
    contactUs: "Nos coordonnées",
    formTitle: "Envoyez-nous un message",
    formName: "Nom",
    formNamePlaceholder: "Votre nom",
    formEmail: "Email",
    formEmailPlaceholder: "Votre email",
    formSubject: "Sujet",
    formSubjectPlaceholder: "Le sujet de votre message",
    formMessage: "Message",
    formMessagePlaceholder: "Votre message",
    formSend: "Envoyer",
    formSuccess: "Message envoyé avec succès",
    sending: "Envoi en cours...",
    company: "Entreprise",
    home: "Accueil",
    about: "À propos",
    careers: "Carrières",
    legal: "Mentions légales",
    ageRange: "Âge",
    nextEvent: "Dates",
    maxStudents: "Élèves",
    included: "Ce qui est inclus",
    materials: "Tous les matériaux nécessaires",
    smallGroups: "Petits groupes (max 10 élèves)",
    certificate: "Certificat de participation",
    availableDates: "Dates disponibles",
    seeAvailability: "Voir disponibilité",
    morning_9_12: "Matin (9h-12h)",
    afternoon_14_17: "Après-midi (14h-17h)",
    fullDay_9_17: "Journée (9h-17h)",
    noStageYet: "Contactez-nous si vous souhaitez vous inscrire à notre camp",
    prev: "Précédent",
    next: "Suivant",
    calendarTitle: "Calendrier des stages",
    calendarSubtitle: "Consultez les prochaines dates de nos stages et réservez votre place",
    registerNow: "Prix",
    closeModal: "Fermer",



    aboutTitle: "À propos de Rebootcamp",
    aboutSubtitle: "Nous inspirons la nouvelle génération de développeurs à travers des stages de programmation innovants et stimulants.",
    aboutOurMission: "Notre Mission",
    aboutOurMissionDescription: "Chez Rebootcamp, nous croyons que chaque enfant devrait avoir l'opportunité d'explorer et de maîtriser la technologie qui façonne notre monde.",
    aboutEducation: "Éducation",
    aboutEducationDescription: "Offrir une éducation technologique de qualité et accessible à tous les enfants et adolescents",
    aboutPassion: "Passion",
    aboutPassionDescription: "Cultiver la passion pour la programmation et l'innovation technologique dès le plus jeune âge",
    aboutCommunity: "Communauté",
    aboutCommunityDescription: "Créer une communauté inclusive où les jeunes peuvent collaborer et grandir ensemble",
    aboutOurStory: "Notre Histoire",
    aboutOurStoryParagraph1: "Rebootcamp a été fondé en 2023 par une enseignante passionné de technologie et d'éducation dont la vision était : rendre l'apprentissage de la programmation accessible, amusant et engageant pour les jeunes.",
    aboutOurStoryParagraph2: "Ce qui a commencé comme un petit atelier de programmation chez des particuliers s'est rapidement transformé en une organisation éducative dynamique, offrant une variété de stages de programmation adaptés à différents niveaux et intérêts.",
    aboutOurStoryParagraph3: "Aujourd'hui, nous sommes fiers d'avoir aidé beaucoup d'enfants à travers la France à découvrir la joie de la création numérique et à développer des compétences qui les prépareront pour l'avenir.",
    aboutStudentsCount: "400+",
    aboutStudentsLabel: "Élèves formés",
    aboutCampsCount: "20+",
    aboutCampsLabel: "Stages différents",
    aboutInstructorsCount: "12+",
    aboutInstructorsLabel: "Instructeurs qualifiés",
    aboutCitiesCount: "3+",
    aboutCitiesLabel: "Villes en France",
    aboutOurTeam: "Notre Équipe",
    aboutTeamMember1Name: "Thomas Dubois",
    aboutTeamMember1Role: "Co-fondateur & CEO",
    aboutTeamMember1Description: "Ingénieur en informatique passionné par l'éducation et l'impact social",
    aboutTeamMember2Name: "Sophie Martin",
    aboutTeamMember2Role: "Co-fondatrice & Directrice Pédagogique",
    aboutTeamMember2Description: "Ancienne enseignante avec 10 ans d'expérience dans l'éducation STEM",
    aboutTeamMember3Name: "Marc Lefèvre",
    aboutTeamMember3Role: "Directeur Technique",
    aboutTeamMember3Description: "Développeur Full Stack spécialisé dans les technologies éducatives",
    aboutJoinOurTeam: "Rejoindre notre équipe",
    aboutOurValues: "Nos Valeurs",
    aboutExcellenceTitle: "Excellence",
    aboutExcellenceDescription: "Nous nous efforçons de fournir une éducation de la plus haute qualité, avec un programme constamment mis à jour et des instructeurs expérimentés.",
    aboutInclusionTitle: "Inclusion",
    aboutInclusionDescription: "Nous croyons que la technologie est pour tout le monde. Nous nous engageons à créer un environnement accueillant et accessible à tous.",
    aboutPracticalLearningTitle: "Apprentissage Pratique",
    aboutPracticalLearningDescription: "Nous privilégions l'apprentissage par la pratique, permettant aux élèves de créer des projets réels qui les passionnent.",
    aboutCaringTitle: "Bienveillance",
    aboutCaringDescription: "Nous cultivons un environnement de soutien où les erreurs sont vues comme des opportunités d'apprentissage et où chacun est encouragé à grandir.",
    aboutQuestionTitle: "Une Question ?",
    aboutQuestionSubtitle: "Nous sommes là pour vous aider à trouver le stage parfait pour votre enfant.",
    aboutContactUsButton: "Contactez-nous",

    stagesTitle: "Nos Stages",
    stagesSubtitle: "Découvrez tous nos stages tech pour enfants et adolescents",
    searchPlaceholder: "Rechercher un stage...",
    ageGroup_all: "Tous",
    ageGroup_6_9: "6-9 ans",
    ageGroup_10_12: "10-12 ans",
    ageGroup_13_15: "13-15 ans",
    ageGroup_16_18: "16-18 ans",
    activeFilters: "Filtres actifs:",
    clearFilters: "Effacer les filtres",
    noResults: "Aucun stage correspondant à vos critères.",
    bookCampTitle: "Réserver ce stage",
    selectDate: "Sélectionner une date",
    selectSession: "Choisir une session",
    morningSession: "Matin (9h-12h)",
    afternoonSession: "Après-midi (14h-17h)",
    fullDaySession: "Journée complète (9h-17h)",
    privateCourse: "Cours privatisé",
    priceLabel: "Prix:",
    bookNowButton: "Réserver maintenant",
    years: "ans",


    careersTitle: "Rejoignez Notre Équipe",
    careersSubtitle: "Aidez-nous à inspirer la prochaine génération d'innovateurs tech à travers une éducation technologique créative et engageante.",
    careerWhyWorkWithUs: "Pourquoi Travailler Avec Rebootcamp?",
    careerContinuousLearning: "Apprentissage Continu",
    careerContinuousLearningDescription: "Nous investissons dans votre croissance avec des opportunités de développement professionnel et de formation.",
    careerCollaborativeCulture: "Culture Collaborative",
    careerCollaborativeCultureDescription: "Travaillez avec des éducateurs et technologues passionnés dans un environnement solidaire.",
    careerMeaningfulImpact: "Impact Significatif",
    careerMeaningfulImpactDescription: "Influencez directement les jeunes esprits et aidez à façonner l'avenir de l'éducation technologique.",
    careerOpenPositions: "Postes Ouverts",
    careerJobRequirements: "Exigences",
    careerJobResponsibilities: "Responsabilités",
    careerApplicationProcess: "Notre Processus de Recrutement",
    careerApplicationStep1: "Soumission de Candidature",
    careerApplicationStep1Description: "Soumettez votre CV et lettre de motivation en ligne. Nous examinons attentivement toutes les candidatures.",
    careerApplicationStep2: "Entretien Initial",
    careerApplicationStep2Description: "Nous planifierons un appel vidéo ou téléphonique pour discuter de votre expérience et de votre intérêt pour notre mission.",
    careerApplicationStep3: "Évaluation des Compétences",
    careerApplicationStep3Description: "Selon le poste, vous pourriez réaliser une tâche liée à vos responsabilités potentielles.",
    careerApplicationStep4: "Entretien Final",
    careerApplicationStep4Description: "Rencontrez notre équipe pour discuter de votre adéquation et répondre à toutes les questions que vous pourriez avoir.",
    careerApplicationStep5: "Offre",
    careerApplicationStep5Description: "Si vous correspondez au profil, nous vous ferons une offre et vous accueillerons dans notre équipe !",
    careerDontSeeAFit: "Vous ne voyez pas de poste qui vous convient ?",
    careerOpenPositionsSubtitle: "Nous recherchons toujours des personnes talentueuses passionnées par l'éducation technologique. Envoyez-nous votre CV et expliquez-nous comment vous pourriez contribuer à notre mission.",
    careerApplyNow: "Postuler Maintenant",
    careerJob1Title: "Enseignant/animateur activité code enfant",
    careerJob1department: "Education",
    careerJob1location: "Toulouse",
    careerJob1Type: "Freelance",
    careerJob1Description: "Nous recherchons des instructeurs passionnés pour enseigner la programmation aux enfants et adolescents pour 1 à 2 heures par semaine (et plus si affinité)",
    careerJob1Requirement1: "Expérience en enseignement ou mentorat",
    careerJob1Requirement2: "Connaissances en programmation (minimum un language)",
    careerJob1Requirement3: "Une expérience avec des enfants",
    careerJob1Requirement4: "Patience et enthousiasme",
    careerJob1Responsability1: "Développer et dispenser des cours de codage",
    careerJob1Responsability2: "Guider et soutenir les élèves",
    careerJob1Responsability3: "Évaluer les progrès des élèves et fournir des feedbacks",
    careerJob1Responsability4: "Gérer les outils à disposition",
    careerJob2Title: "Coordinateur de Stage",
    careerJob2department: "Opérations",
    careerJob2location: "Nice",
    careerJob2Type: "Freelance, CDD",
    careerJob2Description: "Coordonnez nos stages d\'été tech et assurez le bon déroulement de toutes les activités.",
    careerJob2Requirement1: "Expérience en gestion d\'événements ou en éducation",
    careerJob2Requirement2: "Excellentes compétences organisationnelles",
    careerJob2Requirement3: "Fortes capacités interpersonnelles",
    careerJob2Requirement4: "Esprit de résolution de problèmes",
    careerJob2Responsability1: "Gérer la logistique et les plannings des stages et aider à la conception des cours",
    careerJob2Responsability2: "Coordonner avec les instructeurs et le personnel",
    careerJob2Responsability3: "Communiquer avec les parents et les participants",
    careerJob2Responsability4: "Assurer un environnement sûr et productif",
    careerJob3Title: "Enseignant/animateur activité code enfant",
    careerJob3department: "Education",
    careerJob3location: "Nice",
    careerJob3Type: "Freelance",
    careerJob3Description: "Nous recherchons des instructeurs passionnés pour enseigner la programmation aux enfants et adolescents pour 1 à 2 heures par semaine (et plus si affinité)",
    careerJob3Requirement1: "Expérience en enseignement ou mentorat",
    careerJob3Requirement2: "Connaissances en programmation (minimum un language)",
    careerJob3Requirement3: "Une expérience avec des enfants",
    careerJob3Requirement4: "Patience et enthousiasme",
    careerJob3Responsability1: "Développer et dispenser des cours de codage",
    careerJob3Responsability2: "Guider et soutenir les élèves",
    careerJob3Responsability3: "Évaluer les progrès des élèves et fournir des feedbacks",
    careerJob3Responsability4: "Gérer les outils à disposition",
    careerJob4Title: "Apporteur d'affaires",
    careerJob4department: "Commerce",
    careerJob4location: "Remote",
    careerJob4Type: "Freelance",
    careerJob4Description: "Nous recherchons un apporteur d’affaires pour développer notre réseau d’écoles privées et promouvoir nos cours d’informatique pour enfants",
    careerJob4Requirement1: "Expérience en vente BtoB ou développement commercial.",
    careerJob4Requirement2: "Réseau ou connaissance du secteur éducatif privé.",
    careerJob4Requirement3: "Excellentes compétences en communication et négociation",
    careerJob4Requirement4: "Bonne présentation",
    careerJob4Responsability1: "Identifier et prospecter de nouvelles écoles privées.",
    careerJob4Responsability2: "Présenter nos offres et négocier les partenariats.",
    careerJob4Responsability3: "Assurer le suivi des prospects et des contrats signés.",
    careerJob4Responsability4: "Collaborer avec notre équipe pour affiner la stratégie commerciale.",
    careerContactMail: "contact@legros-ines.com",
    careerContacNumber: "+336 04 48 08 16",

    discoverCamps: "Découvrez nos stages",
    seeAllCamps: "Voir tous les stages",
    campSiteWebTitle:"Site Web Low code",
    campSiteWebDescription:"Apprendre à créer un site web avec trés peu de code !",
    campMinecraftTitle: "Minecraft Education",
    campMinecraftDescription: "Apprenez les bases de l'algorithmie avec minecraft",
    campIABaseTitle: "Découverte de l'IA",
    campIABaseDescription: "Cours d'initiation à l'intelligence artificielle et ses utilisations",
    campDigitalArtTitle: "Art digital",
    campDigitalArtDescription: "Utilisation de divers support afin de réaliser une oeuvre digitale originale !",
    campScratchMovieTitle: "Film en Scratch",
    campScratchMovieDescription: "Création d'un film à l'aide de scratch",
    campScratchVideoGameTitle: "Jeux video en Scratch",
    campScratchVideoGameDescription: "Création d'un jeux video à l'aide de scratch",
    campTiktokTitle: "Montage video et chaine tiktok",
    campTiktokDescription: "Apprendre à faire du montage video et créer sa chaine tiktok",
    campLegoRobotTitle: "Début de robotique avec LegoRobot",
    campLegoRobotDescription: "Création d'un robot lego et utilisation du code pour le faire bouger",
    campLapinCretinTitle: "Lapin Crétin",
    campLapinCretinDescription: "Développement de la logique informatique à l'aide des lapins crétins",
    campIAToolTitle: "Création d'un outil IA",
    campIAToolDescription: "Création d'un outil ou d'un site utilisant l'intelligence artificielle et ses API",
    campAnimatedCharacterTitle: "Personnage Animé",
    campAnimatedCharacterDescription: "Création et animation d'un personnage de jeux vidéo",
    campflStudioTitle: "Composer avec FLstudio",
    campflStudioDescription: "Création de musique et de sons à l'aide du logiciel FL studio",
    campBureautiqueTitle: "bureautique",
    campBureautiqueDescription: "Venez apprendre à vous servir d'un ordinateur",
    campPythonTitle:"Python",
    campPythonDescription:"Démarrez votre apprentissage, ou améliorez vous en python!",

    notFoundMessage: "Oops! Cette page a disparu dans le cyberespace.",
    returnToHome: "Retour à l'accueil",

    paymentTitle: "Paiement",
    paymentSubtitle: "Plus qu'une étape !",
    paymentSuccess: "Votre paiement est un succès",
    paymentRedirect: "paymentRedirect",
    paymentInformation: "Informations de paiement",
    paymentOrderSummary: "Résumer des achats",
    paymentAvailability: "Valable 3 mois",
    paymentPrice: "Prix",
    paymentDiscount: "Réduction",
    paymentTax: "Taxes",
    paymentTotal: "Total",
    paymentSecurePayment: "Paiement sécurisé",
    paymentIncompleteCardDetails: "Informations incomplètes",
    paymentNameRequired: "Le nom est nécessaire",
    paymentEmailRequired: "L'email est nécessaire",
    paymentPaymentProcessed: "Paiement en cours...",
    paymentPaymentAmount: "Montant du paiement :",
    paymentGenericPaymentError: "Une erreur s'est produite",
    paymentFullName: "Nom complet",
    paymentCardDetails: "Détails de la carte",
    paymentProcessing: "Paiement en cours ...",
    paymentPayNow: "Payer maintenant",

    viewCamps: "Voir nos stages",
    tarifPageTitle: "Nos tarifs",
    tarifPageSubTitle: "Des options adaptées à tous les besoins et emplois du temps",
    tarifPageMorningOrAfternoon: "Stage matin ou après-midi",
    tarifPageFullDay: "Stage journée complète",
    tarifPagePrivateLesson: "Cours privatisé",
    tarifPageMorningStage: "Matin",
    tarifPageAfternoonStage: "Après-midi",
    tarifPageFullDayStage: "Journée complète",
    tarifPagePrivate: "Privatisé",
    tarifPagePriceMorning: "200€",
    tarifPagePriceFullDay: "350€",
    tarifPagePricePrivate: "1300€",
    tarifPageFiveHalfDays: "5 demi-journées (9h-12h ou 14h-17h)",
    tarifPageFiveFullDays: "5 journées complètes (9h-17h)",
    tarifPagePrivateWeek: "1 semaine sur-mesure avec un formateur dédié",
    tarifPagePopular: "Le plus populaire",
    tarifPageBestValue: "Meilleur rapport qualité-prix",
    tarifPageExclusive: "Expérience exclusive",
    tarifPagePerWeek: "/semaine",
    tarifPageMaterialInformations: "Tout le matériel fourni",
    tarifPageSmallGroup: "Petits groupes (max 12 enfants)",
    tarifPageCertificate: "Certificat de réussite",
    tarifPageSnack: "Collations offertes",
    tarifPageMaisonDeLia: "Visite de la maison de l'IA",
    tarifPageGroupPossibility: "Jusqu'à 8 élèves",
    tarifPageCustomizedProgram: "Programme personnalisé",
    tarifPageSpecialNote: "Note : Des réductions sont disponibles pour les fratries",
};

export default fr;